// extracted by mini-css-extract-plugin
module.exports = {"header":"Details_header__nTGf7","menu":"Details_menu__3Erqm","fields":"Details_fields__3YyZ3"};